'use strict';

var _ = require('lodash');
var d3 = require('d3');
var Scales = function Scales(params, data, range) {
  var flattenData = _.chain(data).map('containerData').flatten().value();
  var yMin = d3.min(flattenData, function (d) {
    return _.min([0, d.m1, d.m2, d.m3, d.m4]);
  });
  var yMax = d3.max(flattenData, function (d) {
    return d.isHidden ? 0 : _.max([0, d.m1, d.m2, d.m3, d.m4]);
  });

  // the brush can modify the visible range of elements
  data = data.slice(range[0], range[1]);
  var x = d3.scale.ordinal().domain(_.map(data, 'd1')).rangeBands([0, params.width], 0, 0);
  var y = d3.scale.linear().domain([yMin, yMax]).range([params.height, 0]);
  return {
    xScale: x,
    yScale: y
  };
};
module.exports = Scales;